
import { mainEventBus } from '../../main';
export const validationMixin = {
   data(){
      return {
         valPhone: ''
      }
   },
   methods: {
      validatePhoneChar(enteredVal){
         // remove spaces
         enteredVal = enteredVal.replace(/\s/g,'');
         if(enteredVal.length <= 0) { return ''; }
         let enteredChar = enteredVal.charAt(enteredVal.length - 1);
         if(enteredVal.length === 1) {
            if(enteredVal !== '+'){
               let firstChar = enteredVal;
               enteredVal = '+' + firstChar;
               mainEventBus.$emit( 'alert', { type:'info', msg:'lbl_phone_first_char_must_be_plus' } );
            }
         }
         if(isNaN(enteredChar)){
            mainEventBus.$emit('alert', {type: 'error', msg: 'lbl_phone_char_must_be_number'});
         }
         enteredVal = (isNaN(enteredChar)) ? enteredVal.slice(0, -1) : enteredVal;
         let phoneVal = '+';

         let a = (enteredVal[0] === '+') ? 1 : 0;
         for( let i=a; i<enteredVal.length; i++){
            if(!isNaN(enteredVal[i])){
               phoneVal += "" + enteredVal[i];
            }
         }
         enteredVal = phoneVal;
         return enteredVal;
      },
      validatePhone(enteredVal){
         // enteredVal = enteredVal.replace(/\s/g,'');
         if(enteredVal.length <= 6) {
            mainEventBus.$emit( 'alert', { type:'warning', msg:'lbl_phone_num_is_too_short' } );
            return false;
         }
         else if(enteredVal.length > 15) {
            mainEventBus.$emit( 'alert', { type:'warning', msg:'lbl_phone_num_is_too_long' } );
            return false;
         }
         else if(enteredVal[0] !== '+'){
            mainEventBus.$emit( 'alert', { type:'warning', msg:'lbl_phone_first_char_must_be_plus' } );
            return false;
         }
         else if(enteredVal.indexOf(' ') >= 0){
            mainEventBus.$emit( 'alert', { type:'warning', msg:'lbl_phone_may_have_no_spaces' } );
            return false;
         }
         for(let i=1; i<enteredVal.length; i++){
            if(isNaN(enteredVal[i])){
               mainEventBus.$emit('alert', {type: 'error', msg: 'lbl_phone_char_must_be_number'});
               return false;
            }
         }
         return true;
      }
   }
};


// WEBPACK FOOTER //
// ./src/Banet/mixins/validationMixin.js